// A job or work-order number that takes you to that job's main project board. Used on
// the Work Flows boards and cards, where the number used to be plain text (Ryan, Sep 2026:
// "when you click the WO number … route back to the main project board").
//
// It stops the click from reaching the card underneath (which would open the card) and
// the mousedown from starting a drag. The office goes to /admin/jobs/:id, a field
// supervisor to their own copy at /sup/jobs/:id.
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function JobNumberLink({ projectId, children, style }) {
  const navigate = useNavigate();
  if (!projectId) return <>{children}</>;
  const to = `${window.location.pathname.startsWith('/sup/') ? '/sup/jobs' : '/admin/jobs'}/${projectId}`;
  return (
    <a href={to} draggable={false} title="Open this job's project board"
      onMouseDown={e => e.stopPropagation()}
      onClick={e => { e.preventDefault(); e.stopPropagation(); navigate(to); }}
      style={{ color: 'inherit', cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: 3, ...style }}>
      {children}
    </a>
  );
}
